import axiosInstance from "@/api/axiosInstance";

/**
 * Delete a hero item
 * DELETE /api/admin/hero-items/{id}
 */
export async function deleteHeroItem(id: string): Promise<void> {
  await axiosInstance.delete(`/api/admin/hero-items/${id}`);
}
